"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var FinanceQuotePricesMultiCurrency_1 = require("./FinanceQuotePricesMultiCurrency");
var FinanceQuotePricesSingleCurrency_1 = require("./FinanceQuotePricesSingleCurrency");
var FinanceQuotePrices = function (props) {
    var labelBefore = props.labelBefore, labelAfter = props.labelAfter, primaryPrice = props.primaryPrice, isMultiCurrency = props.isMultiCurrency, dataTest = props.dataTest, className = props.className, variant = props.variant;
    if (isMultiCurrency) {
        return <FinanceQuotePricesMultiCurrency_1.default {...props}/>;
    }
    return (<FinanceQuotePricesSingleCurrency_1.default labelBefore={labelBefore} className={className} variant={variant} labelAfter={labelAfter} primaryPrice={primaryPrice} dataTest={dataTest}/>);
};
exports.default = FinanceQuotePrices;
